import {
  CalendarViewWeekFilled,
  EventAvailableFilled,
  EventUpcomingFilled,
} from "@clockwise/icons";
import React from "react";
import { Badge, ContentContainer, ContentRow, EducationModal } from "../education-modal";

const PrimaryContent = (
  <ContentContainer>
    <ContentRow>
      <EventAvailableFilled className="cw-text-busy cw-w-4 cw-h-4" />
      <div className="cw-text-13 cw-leading-5">
        Clockwise places events on your calendar{" "}
        <span className="cw-font-semibold">only within the settings</span> you provide.
      </div>
    </ContentRow>
    <ContentRow>
      <EventUpcomingFilled className="cw-text-busy cw-w-4 cw-h-4" />
      <div className="cw-text-13 cw-leading-5">
        As your week changes, Clockwise will make real-time adjustments.
      </div>
    </ContentRow>
    <ContentRow>
      <CalendarViewWeekFilled className="cw-text-busy cw-w-4 cw-h-4" />
      <div className="cw-text-13 cw-leading-5">
        Make sense of your calendar with{" "}
        <span className="cw-font-semibold">automatic event color-coding</span> based on smart
        categories.
      </div>
    </ContentRow>
  </ContentContainer>
);

// TODO: Update this copy when designs are updated, this is the right format but rescheduling copy
const SecondaryContent = (
  <ContentContainer>
    <ContentRow>
      <Badge>1</Badge> <div className="cw-text-13 cw-leading-5">Select a meeting </div>
    </ContentRow>
    <ContentRow>
      <Badge>2</Badge>
      <div className="cw-text-13 cw-leading-5">
        Choose a time that works best for you and your attendees
      </div>
    </ContentRow>
    <ContentRow>
      <Badge>3</Badge>
      <div className="cw-text-13 cw-leading-5">Confirm the move and you're done!</div>
    </ContentRow>
    <div className="cw-text-13 cw-leading-5">
      Want to learn more?{" "}
      <span className="cw-text-positive-muted cw-font-semibold cw-cursor-pointer">
        Talk to a CSM
      </span>{" "}
      about best practices and using Clockwise with your team.
    </div>
  </ContentContainer>
);

export const NUXPreferencesModal = ({
  onClose,
  onClickAction,
}: {
  onClose: () => void;
  onClickAction: () => void;
}) => {
  return (
    <EducationModal
      header="Calendar preferences"
      subheader="Design your ideal week with helpful automations for your calendar, from meeting breaks to lunch."
      primaryButtonText="Go to settings"
      mainContent={PrimaryContent}
      isOpen={true}
      onClose={onClose}
      onClickPrimaryButton={onClickAction}
      videoLink=""
      secondaryContent={SecondaryContent}
      onClickSecondaryButton={onClose}
    />
  );
};
